module.exports = __webpack_public_path__ + "img/yama-icon.a6a9f667.png";